module.exports = __webpack_public_path__ + "img/image-post-empty.032d27c4.svg";